import { useState } from "react";
import Icon from "../../components/shared/Icon";
import { Card, Input, Select, Btn, Table } from "../../components/shared/UIComponents";

export default function EditMemberDetails() {
  const [activeTab, setActiveTab] = useState("profile");
  const tabs = [
    { id: "profile", label: "Profile Info" }, { id: "contact", label: "Contact Info" },
    { id: "password", label: "Password Update" }, { id: "picture", label: "Profile Picture" },
    { id: "flat-transfer", label: "Flat Transfer" }, { id: "tenant", label: "Tenant Info" },
    { id: "family", label: "Family Info" }, { id: "vehicle", label: "Vehicle Info" },
    { id: "lein", label: "Lein Info" }, { id: "mortgage", label: "Mortagage Info" },
    { id: "joint", label: "Joint Info" }, { id: "nominee", label: "Nominee Registers" },
    { id: "shares", label: "Shares Registers" }, { id: "opening", label: "Opening Balance" },
  ];

  const renderTab = () => {
    switch (activeTab) {
      case "profile": return (
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: 16 }}>
          <Select label="Salutation" options={["Mr", "Mrs", "Ms", "Dr"]} />
          <Input label="Name" defaultValue="Abhishek Singh" />
          <Input label="UserName" defaultValue="bhoomiF0102" />
          <Input label="Flat" defaultValue="bhoomiF0102~F0102" />
          <Input label="Building Name" defaultValue="bhoomi" />
          <Select label="Member Type" options={["Sub Committe Member", "Owner", "Tenant"]} />
          <Input label="Area" defaultValue="875" />
          <Input label="Additional Area" placeholder="Sq Ft" />
          <Select label="Unit Type" options={["1 BHK/T", "2 BHK/T", "3 BHK/T", "Studio"]} />
          <div style={{ display: "flex", gap: 16 }}>
            <label style={{ fontSize: 13, display: "flex", alignItems: "center", gap: 5 }}><input type="radio" name="us" defaultChecked />Owner</label>
            <label style={{ fontSize: 13, display: "flex", alignItems: "center", gap: 5 }}><input type="radio" name="us" />Tenant</label>
          </div>
          <Input label="Parking (2 Whr)" defaultValue="2" />
          <Input label="Parking (4 Whr)" defaultValue="1" />
          <Input label="Wing" defaultValue="A" />
          <Input label="Floor No" defaultValue="10" />
          <Input label="Date Of Admission" type="date" defaultValue="2025-10-01" />
          <Input label="Date Of Payment Entrance" type="date" defaultValue="2025-07-10" />
          <Input label="Date Of Cessation" type="date" defaultValue="2025-10-05" />
          <Input label="Reason Of Cessation" defaultValue="sold" />
          <div style={{ gridColumn: "span 4", marginTop: 8 }}><Btn>Update Profile</Btn></div>
        </div>
      );
      case "contact": return (
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
          <Input label="Postal Address" defaultValue="bhoomi" />
          <Input label="Landline No" defaultValue="022124566624" />
          <Input label="Mobile No" defaultValue="9125100106" />
          <Input label="Email" defaultValue="as@gmail.com" />
          <Input label="Social Network Profile Page" placeholder="Should begin with http://" />
          <Input label="Personal HomePage/Blog Url" placeholder="Should begin with http://" />
          <div style={{ gridColumn: "span 2" }}><Btn>Update Contact Details</Btn></div>
        </div>
      );
      case "password": return (
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 16 }}>
          <Input label="Old Password" type="password" defaultValue="12345" />
          <Input label="New Password" type="password" placeholder="Enter New Password" />
          <Input label="Confirm Password" type="password" placeholder="Enter Confirm Password" />
          <div><Btn>Save</Btn></div>
        </div>
      );
      case "picture": return (
        <div>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: "block", fontSize: 12, fontWeight: 600, color: "#78909c", marginBottom: 6 }}>Choose Picture For Upload</label>
            <input type="file" accept="image/*" style={{ fontSize: 13 }} />
          </div>
          <Btn>Upload</Btn>
          <div style={{ marginTop: 16, width: 80, height: 80, background: "#f5f7fa", borderRadius: 8, border: "1px solid #e0e0e0" }} />
        </div>
      );
      case "flat-transfer": return (
        <Table columns={["SrNo", "Member Name", "Mobile", "Email", "Reason", "Cessation Date", "Admission Date", "Delete"]}
          rows={[
            { n: "Dilip Namdev Dalvi", m: "8976412930", e: "", r: "", c: "2024-09-18", a: "2024-09-17" },
            { n: "R.Rout", m: "6267935013", e: "", r: "sold", c: "2024-09-30", a: "2025-05-23" },
            { n: "R.Rout", m: "9819700594", e: "amitab@gmail.com", r: "sold", c: "2025-10-05", a: "2025-10-01" },
          ]}
          renderRow={(r, i) => [
            <td style={{ padding: "9px 12px" }}>{i + 1}</td>,
            <td style={{ padding: "9px 12px", fontWeight: 500 }}>{r.n}</td>,
            <td style={{ padding: "9px 12px" }}>{r.m}</td>,
            <td style={{ padding: "9px 12px", fontSize: 12 }}>{r.e}</td>,
            <td style={{ padding: "9px 12px" }}>{r.r}</td>,
            <td style={{ padding: "9px 12px" }}>{r.c}</td>,
            <td style={{ padding: "9px 12px" }}>{r.a}</td>,
            <td style={{ padding: "9px 12px" }}><button style={{ background: "#fce8e6", border: "none", borderRadius: 5, padding: "3px 8px", cursor: "pointer", color: "#c62828", fontSize: 12 }}>🗑️</button></td>,
          ]}
        />
      );
      case "tenant": return (
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
          <div style={{ gridColumn: "span 2" }}><label style={{ fontSize: 13, display: "flex", alignItems: "center", gap: 5 }}><input type="checkbox" defaultChecked style={{ accentColor: "#1565c0" }} />Active</label></div>
          <Input label="Tenant Name" placeholder="Enter Tenant Name" />
          <Input label="Mobile No" placeholder="Enter Mobile No" />
          <Input label="Email Id" placeholder="Enter Email Id" />
          <Input label="Agreement Start Date" type="date" />
          <Input label="Agreement End Date" type="date" />
          <Input label="Address" placeholder="Enter Address" />
          <Input label="Pan No" placeholder="Enter Pan No" />
          <Input label="Aadhar No" placeholder="Enter Aadhar No" />
          <Input label="GST No" placeholder="Enter Gst No" />
          <Input label="Notes" placeholder="Enter Notes" />
          <div style={{ gridColumn: "span 2" }}><Btn>Save</Btn></div>
        </div>
      );
      case "family": return (
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
          <Input label="Member Name" placeholder="Enter Member Name" />
          <Input label="Date Of Birth" type="date" />
          <Input label="Mobile No" placeholder="Enter Mobile No" />
          <Input label="Email Id" placeholder="Enter Email Id" />
          <Input label="Member Badge No" placeholder="Enter Member Badge No" />
          <Input label="Notes" placeholder="Enter Notes" />
          <div style={{ gridColumn: "span 2" }}><Btn>Save</Btn></div>
        </div>
      );
      case "vehicle": return (
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: 16 }}>
          <div style={{ gridColumn: "span 4" }}><label style={{ fontSize: 13, display: "flex", alignItems: "center", gap: 5 }}><input type="checkbox" style={{ accentColor: "#1565c0" }} />Select to Apply Parking Charges</label></div>
          <Input label="Slot No" placeholder="Enter Slot No" />
          <Input label="Sticker No" placeholder="Enter Sticker No" />
          <Input label="Model" placeholder="Enter Model" />
          <Input label="Vehicle No" placeholder="Enter Vehicle No" />
          <Select label="Slot Type" options={["Select", "Open", "Covered", "Basement"]} />
          <Select label="Parking Type" options={["Select", "Allotted", "Unallotted"]} />
          <div style={{ display: "flex", gap: 10 }}><label style={{ fontSize: 13, display: "flex", alignItems: "center", gap: 5 }}><input type="radio" name="wh" />2 Wheeler</label><label style={{ fontSize: 13, display: "flex", alignItems: "center", gap: 5 }}><input type="radio" name="wh" />4 Wheeler</label></div>
          <div style={{ gridColumn: "span 4" }}><Btn>Save</Btn></div>
        </div>
      );
      case "lein": return (
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
          <div><label style={{ display: "block", fontSize: 11, fontWeight: 600, color: "#78909c", marginBottom: 5, textTransform: "uppercase" }}>Lending Bankers</label><textarea placeholder="Lending Bankers" style={{ width: "100%", padding: "9px 12px", border: "1.5px solid #e0e0e0", borderRadius: 8, fontSize: 13, boxSizing: "border-box", height: 80 }} /></div>
          <div><label style={{ display: "block", fontSize: 11, fontWeight: 600, color: "#78909c", marginBottom: 5, textTransform: "uppercase" }}>Remark</label><textarea placeholder="Remark" style={{ width: "100%", padding: "9px 12px", border: "1.5px solid #e0e0e0", borderRadius: 8, fontSize: 13, boxSizing: "border-box", height: 80 }} /></div>
          <Input label="Lending Date" type="date" />
          <Input label="Closer Date" type="date" />
          <div style={{ gridColumn: "span 2" }}><Btn>Save</Btn></div>
        </div>
      );
      case "mortgage": return (
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
          <Input label="Mortgage Bank" placeholder="Enter Mortagage Bank" />
          <Input label="Mortgage Branch" placeholder="Enter Mortgage Branch" />
          <div><Btn>Save</Btn></div>
        </div>
      );
      case "joint": return (
        <div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 16, marginBottom: 16 }}>
            <div><label style={{ fontSize: 13, display: "flex", alignItems: "center", gap: 5 }}><input type="checkbox" style={{ accentColor: "#1565c0" }} />Tick to Show in Bills</label></div>
            <Input label="Joint Name" placeholder="Enter Joint Member Name" />
            <Select label="Class of Member" options={["select class of member", "Ordinary", "Associate", "Nominal"]} />
            <div><label style={{ display: "block", fontSize: 11, fontWeight: 600, color: "#78909c", marginBottom: 5, textTransform: "uppercase" }}>Address</label><textarea placeholder="Enter Address" style={{ width: "100%", padding: "9px 12px", border: "1.5px solid #e0e0e0", borderRadius: 8, fontSize: 13, boxSizing: "border-box", height: 70 }} /></div>
            <div><label style={{ display: "block", fontSize: 11, fontWeight: 600, color: "#78909c", marginBottom: 5, textTransform: "uppercase" }}>Remark</label><textarea placeholder="Enter Remark" style={{ width: "100%", padding: "9px 12px", border: "1.5px solid #e0e0e0", borderRadius: 8, fontSize: 13, boxSizing: "border-box", height: 70 }} /></div>
          </div>
          <Btn style={{ marginBottom: 16 }}>Save</Btn>
          <Table columns={["SrNo", "Joint Name", "Address", "Remark", "Class", "Edit", "Delete"]}
            rows={[{ n: "Testing", a: "Vechi", r: "", c: "Ordinary" }]}
            renderRow={(r, i) => [
              <td style={{ padding: "9px 12px" }}>{i + 1}</td>,
              <td style={{ padding: "9px 12px" }}>{r.n}</td>,
              <td style={{ padding: "9px 12px" }}>{r.a}</td>,
              <td style={{ padding: "9px 12px" }}>{r.r}</td>,
              <td style={{ padding: "9px 12px" }}>{r.c}</td>,
              <td style={{ padding: "9px 12px" }}><button style={{ background: "#fff3e0", border: "none", borderRadius: 5, padding: "3px 8px", cursor: "pointer", fontSize: 12 }}>✏️</button></td>,
              <td style={{ padding: "9px 12px" }}><button style={{ background: "#fce8e6", border: "none", borderRadius: 5, padding: "3px 8px", cursor: "pointer", fontSize: 12 }}>🗑️</button></td>,
            ]}
          />
        </div>
      );
      case "nominee": return (
        <div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 16 }}>
            <Input label="Name Of Nominee" placeholder="Enter Name Of Nominee" />
            <Input label="Address of Nominee" placeholder="Enter Address of Nominee" />
            <Input label="Date of Nomination" type="date" />
            <Input label="Date of Committee Meeting" type="date" />
            <Input label="Date of Revocation" type="date" />
            <Input label="Remarks" placeholder="Enter Remarks" />
          </div>
          <Btn style={{ marginBottom: 16 }}>Save</Btn>
          <Table columns={["SrNo", "Name", "Address", "NominationDate", "Edit", "Delete"]}
            rows={[{ n: "Kamal Mani Pal Dalvi", a: "Mahvir Nagar Plot No:45 Sector.67.", d: "2024-04-05" }]}
            renderRow={(r, i) => [
              <td style={{ padding: "9px 12px" }}>{i + 1}</td>,
              <td style={{ padding: "9px 12px", fontWeight: 500 }}>{r.n}</td>,
              <td style={{ padding: "9px 12px", fontSize: 12 }}>{r.a}</td>,
              <td style={{ padding: "9px 12px" }}>{r.d}</td>,
              <td style={{ padding: "9px 12px" }}><button style={{ background: "#fff3e0", border: "none", borderRadius: 5, padding: "3px 8px", cursor: "pointer", fontSize: 12 }}>✏️</button></td>,
              <td style={{ padding: "9px 12px" }}><button style={{ background: "#fce8e6", border: "none", borderRadius: 5, padding: "3px 8px", cursor: "pointer", fontSize: 12 }}>🗑️</button></td>,
            ]}
          />
        </div>
      );
      case "shares": return (
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
          <Input label="Share Certificate No" placeholder="Enter Share Certificate No" />
          <Input label="No Of Shares" placeholder="Enter No Of Shares" />
          <Input label="Share From" placeholder="Enter Share From" />
          <Input label="Share To" placeholder="Enter Share To" />
          <Input label="Date Of Issue" type="date" />
          <Input label="Remarks" placeholder="Enter Remarks" />
          <div style={{ gridColumn: "span 2" }}><Btn>Save</Btn></div>
        </div>
      );
      case "opening": return (
        <Table columns={["Opening Balance", "GST", "Interest", "Total", "Type", "DueDate"]}
          rows={[
            { ob: "-10344346.98", g: "0.00", i: "0.00", t: "-10344346.98", ty: "Regular", d: "2025-03-31" },
            { ob: "0.00", g: "0.00", i: "0.00", t: "0.00", ty: "Supplimentary", d: "" },
          ]}
          renderRow={(r) => [
            <td style={{ padding: "9px 12px", color: r.ob.includes("-") ? "#d32f2f" : "#263238" }}>{r.ob}</td>,
            <td style={{ padding: "9px 12px" }}>{r.g}</td>,
            <td style={{ padding: "9px 12px" }}>{r.i}</td>,
            <td style={{ padding: "9px 12px", fontWeight: 600, color: r.t.includes("-") ? "#d32f2f" : "#263238" }}>{r.t}</td>,
            <td style={{ padding: "9px 12px" }}><span style={{ padding: "3px 8px", background: r.ty === "Regular" ? "#e3f2fd" : "#f3e5f5", color: r.ty === "Regular" ? "#1565c0" : "#7b1fa2", borderRadius: 5, fontSize: 12 }}>{r.ty}</span></td>,
            <td style={{ padding: "9px 12px" }}><input type="date" defaultValue={r.d} style={{ padding: "4px 8px", border: "1px solid #e0e0e0", borderRadius: 5, fontSize: 12 }} /></td>,
          ]}
        />
      );
      default: return <div style={{ padding: 20, color: "#90a4ae" }}>Select a tab</div>;
    }
  };

  return (
    <div>
      <div style={{ marginBottom: 16, fontSize: 14, color: "#546e7a" }}>
        Member Profile :- Abhishek Singh &nbsp; Flat No:- F0102 &nbsp;
        <span style={{ color: "#1565c0", cursor: "pointer", fontWeight: 500 }}>Go Back</span>
      </div>
      <Card>
        {tabs.map(tab => (
          <div key={tab.id}>
            <div onClick={() => setActiveTab(activeTab === tab.id ? null : tab.id)} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 20px", cursor: "pointer", borderBottom: "1px solid #f0f0f0", background: activeTab === tab.id ? "#f0f7ff" : "#fff" }}>
              <span style={{ fontSize: 14, fontWeight: 500, color: activeTab === tab.id ? "#1565c0" : "#263238" }}>{tab.label}</span>
              <Icon name={activeTab === tab.id ? "chevronDown" : "chevronRight"} size={14} color="#546e7a" />
            </div>
            {activeTab === tab.id && <div style={{ padding: 20, borderBottom: "1px solid #f0f0f0" }}>{renderTab()}</div>}
          </div>
        ))}
      </Card>
    </div>
  );
}
